import React, { useEffect, useState } from 'react';
import './FinePrompt.scss';

interface ShowEventDetail {
  target: number;
  targetName: string;
}

const send = (payload: Record<string, unknown>): void => {
  if ((window as any).skyrimPlatform?.sendMessage) {
    (window as any).skyrimPlatform.sendMessage(JSON.stringify({ source: 'fine-prompt', ...payload }));
  }
};

// Reached from the player target-menu's "Mettre une amende" option
// (identityService.ts, gated on the canFine faction permission) - not a
// chat command, see justiceSystem.ts's own header comment on why.
const FinePrompt: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [target, setTarget] = useState<number | null>(null);
  const [targetName, setTargetName] = useState('');
  const [amountDraft, setAmountDraft] = useState('100');

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as ShowEventDetail;
      setTarget(detail.target);
      setTargetName(detail.targetName || 'cette personne');
      setAmountDraft('100');
      setVisible(true);
    };
    window.addEventListener('skymp5-client:showFinePrompt', handler);
    return () => window.removeEventListener('skymp5-client:showFinePrompt', handler);
  }, []);

  const close = () => {
    setVisible(false);
    send({ action: 'close' });
  };

  const confirm = () => {
    if (target === null) return;
    const amount = Number(amountDraft);
    if (!Number.isFinite(amount) || amount <= 0) return;
    send({ action: 'confirm', target, amount });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fine-prompt">
      <div className="fine-prompt__window skyrim-panel">
        <div className="fine-prompt__header">
          <span className="fine-prompt__title">Mettre une amende</span>
        </div>

        <div className="fine-prompt__body">
          <p className="fine-prompt__target">à {targetName}</p>
          <label className="fine-prompt__label">Montant (Septims)</label>
          <input
            className="fine-prompt__input"
            type="number"
            min="1"
            value={amountDraft}
            onChange={(e) => setAmountDraft(e.target.value)}
            autoFocus
          />
        </div>

        <div className="fine-prompt__footer">
          <button type="button" className="fine-prompt__button fine-prompt__button--secondary" onClick={close}>
            Annuler
          </button>
          <button type="button" className="fine-prompt__button" onClick={confirm}>
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinePrompt;
